import { ComponentRoute } from '@/classes'

const SuperadminSystemMessageRoutes = {
  SystemMessageView: new ComponentRoute('/superadmin/systemmessage', 'SystemMessageView'),
  SystemMessageDetail: new ComponentRoute('/superadmin/systemmessage', 'SystemMessageDetail')
}

export default SuperadminSystemMessageRoutes
